import { roles } from '@/config/roles'

const routes = [
  {
    name: 'ContentAwait',
    path: '/content/await',
    component: () => import('@/views/content/verification/Await'),
    meta: {
      roles: [roles.verification]
    }
  },
  {
    name: 'ContentEventVerification',
    path: '/content/:type/event/:id',
    component: () => import('@/views/content/events/Event'),
    meta: {
      roles: [roles.verification]
    }
  },
  {
    name: 'ContentSingleNewsVerification',
    path: '/content/:type/news/:id',
    component: () => import('@/views/content/news/Verification'),
    meta: {
      roles: [roles.verification]
    }
  },
  {
    name: 'ContentCourseVerification',
    path: '/content/:type/course/:id',
    component: () => import('@/views/content/courses/Verification'),
    meta: {
      roles: [roles.verification]
    }
  },
  {
    name: 'ContentTrainingVerification',
    path: '/content/:type/training/:id',
    component: () => import('@/views/content/training/Verification'),
    meta: {
      roles: [roles.verification]
    }
  },
  {
    name: 'ContentClassVerification',
    path: '/content/:type/class/:id',
    component: () => import('@/views/content/classes/Verification'),
    meta: {
      roles: [roles.verification]
    }
  },
  {
    name: 'ContentPartnerVerification',
    path: '/content/:type/partner/:id',
    component: () => import('@/views/content/partners/Verification'),
    meta: {
      roles: [roles.verification]
    }
  },
  {
    name: 'ContentAccepted',
    path: '/content/accepted',
    component: () => import('@/views/content/verification/Accepted'),
    meta: {
      roles: [roles.verification]
    }
  },
  {
    name: 'ContentRejected',
    path: '/content/rejected',
    component: () => import('@/views/content/verification/Rejected'),
    meta: {
      roles: [roles.verification]
    }
  },
  {
    name: 'ContentRemoved',
    path: '/content/removed',
    component: () => import('@/views/content/verification/Removed'),
    meta: {
      roles: [roles.verification]
    }
  }
]

export default routes
